<template>
  <div class="container-full-width" @click="unClick">
    <div
      class="files-view"
      @contextmenu.prevent.capture="contextMenu($event, undefined)"
    >
      <!-- Uploader + manager -->
      <FileBrowser
        :module="module"
        :unique-folder-id="uniqueFolderId"
        :identifier="identifier"
        :multiple="multiple"
        :max-files="maxFiles"
        :deletable-on-create="deletableOnCreate"
        :deletable-on-edit="deletableOnEdit"
      ></FileBrowser>
    </div>
  </div>
</template>

<script>
//import DesktopSortingAndPreview from '@assets/js/components/DesktopSortingAndPreview'
//import DesktopToolbar from '@assets/js/components/DesktopToolbar'
import FileBrowser from '@assets/js/components/FileBrowser'
// import FileFullPreview from '@assets/js/components/FileFullPreview'
import { mapGetters } from 'vuex'
import { events } from '@main/js/bus'

export default {
  name: 'FilesView',
  components: {
    FileBrowser,
  },
  props: {
    uniqueFolderId: {
      type: [Number, String],
      default: null,
    },
    module: {
      type: [Number, String],
      default: null,
    },
    identifier: {
      type: [Number, String],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    maxFiles: {
      type: [Number, String],
      default: null,
    },
    deletableOnCreate: {
      type: Boolean,
      default: true,
    },
    deletableOnEdit: {
      type: Boolean,
      default: true,
    },
  },
  computed: {},
  mounted() {},
  methods: {
    contextMenu(event, item) {
      events.$emit('contextMenu:show', event, item)
    },
    unClick() {
      events.$emit('unClick')
    },
  },
}
</script>

<style lang="scss">
[v-cloak],
[v-cloak] > * {
  display: none;
}

.files-view {
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
  width: 100%;
  height: 100%;
  position: relative;
  min-width: 320px;
  min-height: 100px;
  overflow-x: hidden;
  padding-left: 0;
  padding-right: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  overflow-y: hidden;
  border: 2px dashed rgba(109, 164, 203, 0.72);
  border-radius: 6px;
}

@media only screen and (max-width: 690px) {
  .files-view {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
